@if ((modelsLoading$ | async) === 'loaded') {
  <h3-production-workspace-navbar [stepId]="stepId" [templateId]="templateId">
  </h3-production-workspace-navbar>

  @if (isUsingGenAi$ | async) {
    <h3-gen-ai-container>
      <h3-production-workspace-header
        [previousTask]="previousTask"
        projection-location="header"
      ></h3-production-workspace-header>
    </h3-gen-ai-container>
  } @else if (isUsingCategorization$ | async) {
    <h3-categorization-container>
      <h3-production-workspace-header
        projection-location="header"
      ></h3-production-workspace-header>
    </h3-categorization-container>
  } @else {
    <h3-production-workspace-header
      [previousTask]="previousTask"
    ></h3-production-workspace-header>
    <form
      class="workspace-outline"
      *ngIf="(hideAll$ | async) === false"
      (submit)="$event.preventDefault()"
    >
      <h3-root-h3ml-container></h3-root-h3ml-container>
      @if (!isNavbarSubmitButtonEnabled) {
        <hr />
        <div class="footer-row">
          <h3-submit-task-button> </h3-submit-task-button>
        </div>
      }
    </form>
  }
}
